/**
 * Attendance tracks whether the patient actually showed up for the appointment.
 * It is intentionally independent from AppointmentStatus (booking lifecycle).
 */
enum Attendance {
    UNKNOWN = 'unknown',
    PRESENT = 'present',
    NO_SHOW = 'no_show',
}

export default Attendance;
